import { getObjectKeysAsObject } from "@checkout/helpers";
import { updatePassengerWithPassportService } from "./updatePassengerWithPassportService";

export const services = {
  updatePassengerWithPassportService,
};

export const ServiceTypes = getObjectKeysAsObject(services);
